

export enum EIntervalMode {
    default = -1,
    allTime = 0,
    year = 1,
    month = 2,
    week = 3,
    day = 4,
    currentMonth = 5,
    previousMonth = 6,
    nextMonth = 7
}

export interface ITimespanString {
    start: string,
    end: string
}

export class TimeUtils {

    /**
     * get seconds and returns a standard representation in string format
     * @param seconds 
     * @param showSeconds 
     */
    static formatTimeFromSeconds(seconds: number, showSeconds: boolean): string {
        if ((seconds == null) && (seconds !== 0)) {
            return null;
        }

        const sec: number = Math.floor(seconds);
        const h = Math.floor(sec / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const s = sec % 60;

        // let hours: number = Math.floor(secondsInput / 3600);
        // let minutes: number = Math.floor((secondsInput - (hours * 3600)) / 60);
        // let seconds: number = secondsInput - (hours * 3600) - (minutes * 60);

        let ts: string = "";

        if (h < 10) {
            ts += "0";
        }
        ts += h + ":";
        if (m < 10) {
            ts += "0";
        }
        ts += m;

        if (showSeconds) {
            ts += ":";
            if (s < 10) {
                ts += "0";
            }
            ts += s;
        }

        return ts;
    }

    /**
    * get seconds and returns a standard representation in string format
    * @param seconds 
    * @param showSeconds 
    */
    static formatElapsedFromSecondsMessage(seconds: number, showSeconds: boolean): string {
        if ((seconds == null) && (seconds !== 0)) {
            return null;
        }

        const sec: number = Math.floor(seconds);
        const h = Math.floor(sec / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const s = sec % 60;

        let ts: string = "";

        if (h > 0) {
            ts += h + "h ";
        }
        if (m > 0) {
            ts += m + " min";
            if (showSeconds) {
                ts += " ";
            }
        }

        if (showSeconds) {
            ts += s + " sec";
        }

        return ts;
    }

    /**
     * get seconds and returns a standard representation in string format
     * @param seconds 
     * @param showSeconds 
     */
    static formatTimeSpeechFromSeconds(seconds: number, adaptivePrecision: boolean): string[] {
        if ((seconds == null) && (seconds !== 0)) {
            return null;
        }

        const sec: number = Math.floor(seconds);
        const h = Math.floor(sec / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const s = sec % 60;

        // let hours: number = Math.floor(secondsInput / 3600);
        // let minutes: number = Math.floor((secondsInput - (hours * 3600)) / 60);
        // let seconds: number = secondsInput - (hours * 3600) - (minutes * 60);

        let ts: string = "";
        let article: string = ""; // there is/are

        if (!adaptivePrecision) {
            if (h > 0) {
                ts += h + ((h > 1) ? " hours" : " hour");
                article = (h > 1) ? "are" : "is";
                if (m > 0) {
                    ts += ", " + m + ((m > 1) ? " minutes" : " minute");
                }
                if (s > 0) {
                    ts += " and " + s + ((s > 1) ? " seconds" : " second");
                }
            } else {
                if (m > 0) {
                    ts += m + ((m > 1) ? " minutes" : " minute");
                    article = (m > 1) ? "are" : "is";
                    if (s > 0) {
                        ts += " and " + s + ((s > 1) ? " seconds" : " second");
                    }
                } else {
                    ts += s + ((s > 1) ? " seconds" : " second");
                    article = (s > 1) ? "are" : "is";
                }
            }
        } else {
            if (h > 0) {
                ts += h + ((h > 1) ? " hours" : " hour");
                article = (h > 1) ? "are" : "is";
                if (m > 0) {
                    ts += " and " + m + ((m > 1) ? " minutes" : " minute");
                }
            } else {
                if (m > 0) {
                    ts += m + ((m > 1) ? " minutes" : " minute");
                    article = (m > 1) ? "are" : "is";
                } else {
                    ts += s + ((s > 1) ? " seconds" : " second");
                    article = (s > 1) ? "are" : "is";
                }
            }
        }

        return [ts, article];
    }


    static isNight() {
        // Returns true if the time is between
        // 7pm to 5am
        let time = new Date().getHours();
        return (time > 5 && time < 19) ? false : true;
    }


    /**
     * get seconds and return a message context representation in string format
     * @param secondsInput 
     * @param attribute 
     */
    static formatTimeFromSeconds2(secondsInput: number, attribute: boolean): string {
        let valString: string = "";
        if ((secondsInput == null) && (secondsInput !== 0)) {
            return null;
        }

        let hours: number = Math.floor(secondsInput / 3600);
        let minutes: number = Math.floor((secondsInput - (hours * 3600)) / 60);
        // let seconds: number = secondsInput - (hours * 3600) - (minutes * 60);

        if (hours > 0) {
            valString += hours + "h";
            if (minutes > 0) {
                valString += minutes + "'";
            }
        } else {
            if (minutes > 0) {
                if (attribute) {
                    valString += minutes + "-Minute";
                } else {
                    valString += minutes + " minutes";
                }
            }
        }
        return valString;
    }


    static removeTimePart(dateString: string): string {
        if (dateString == null) {
            return "";
        }
        return dateString.split("T")[0];
    }

    /**
     * format date as [numeric day] [string month] [full year]
     * @param dateString 
     */
    static formatDateDisp(dateString: string | number): string {
        if (dateString == null) {
            return "";
        }

        let date = new Date(dateString);
        let yourDateformat = date.getUTCDate() + " " + TimeUtils.getShortMonthName(date.getUTCMonth()) + " " + date.getUTCFullYear();
        return yourDateformat;
    }

    /**
     * format date as [string day], [string month] [numeric day]
     * @param dateString 
     */
    static formatDateDispV2(dateString: string | number): string {
        if (dateString == null) {
            return "";
        }

        let date = new Date(dateString);
        let yourDateformat = TimeUtils.getShortDayNames(date.getUTCDay()) + ", " + TimeUtils.getShortMonthName(date.getUTCMonth()) + " " + date.getUTCDate();
        return yourDateformat;
    }

    /**
   * format date time as [numeric day] [string month] [full year] [hh:mm:ss]
   * @param dateString 
   * @param contextDate 
   */
    static formatDateTimeDisp(dateString: string | number, contextDate: boolean, withSeconds: boolean): string {
        if (dateString == null) {
            return "";
        }

        let date: Date = new Date(dateString);
        let dateNow: Date = new Date();

        let yourDateformat: string = "";

        if (contextDate) {
            if ((dateNow.getTime() - date.getTime()) > (24 * 3600 * 1000)) {
                yourDateformat += TimeUtils.formatDateDisp(dateString) + " ";
            }
        } else {
            yourDateformat += TimeUtils.formatDateDisp(dateString) + " ";
        }

        yourDateformat += TimeUtils.formatTimeDispExtract(dateString, withSeconds);

        return yourDateformat;
    }

    static formatTimeDispExtract(dateString: string | number, withSeconds: boolean): string {
        let date = new Date(dateString);
        let seconds: number = date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds();
        return TimeUtils.formatTimeFromSeconds(seconds, withSeconds);
    }

    static getShortMonthName(month: number): string {
        let monthNames: string[] = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        return monthNames[month];
    }

    static getShortDayNames(day: number): string {
        let dayNames: string[] = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        return dayNames[day];
    }





    /**
        Format Dates
     
        moment().format('MMMM Do YYYY, h:mm:ss a'); // May 13th 2019, 9:37:28 pm
        moment().format('dddd');                    // Monday
        moment().format("MMM Do YY");               // May 13th 19
        moment().format('YYYY [escaped] YYYY');     // 2019 escaped 2019
        moment().format();                          // 2019-05-13T21:37:28+03:00

        Relative Time

        moment("20111031", "YYYYMMDD").fromNow(); // 8 years ago
        moment("20120620", "YYYYMMDD").fromNow(); // 7 years ago
        moment().startOf('day').fromNow();        // a day ago
        moment().endOf('day').fromNow();          // in 2 hours
        moment().startOf('hour').fromNow();       // 38 minutes ago

        Calendar Time

        moment().subtract(10, 'days').calendar(); // 05/03/2019
        moment().subtract(6, 'days').calendar();  // Last Tuesday at 9:38 PM
        moment().subtract(3, 'days').calendar();  // Last Friday at 9:38 PM
        moment().subtract(1, 'days').calendar();  // Yesterday at 9:38 PM
        moment().calendar();                      // Today at 9:38 PM
        moment().add(1, 'days').calendar();       // Tomorrow at 9:38 PM
        moment().add(3, 'days').calendar();       // Thursday at 9:38 PM
        moment().add(10, 'days').calendar();      // 05/23/2019

        Multiple Locale Support
        moment.locale();         // en
        moment().format('LT');   // 9:38 PM
        moment().format('LTS');  // 9:38:48 PM
        moment().format('L');    // 05/13/2019
        moment().format('l');    // 5/13/2019
        moment().format('LL');   // May 13, 2019
        moment().format('ll');   // May 13, 2019
        moment().format('LLL');  // May 13, 2019 9:38 PM
        moment().format('lll');  // May 13, 2019 9:38 PM
        moment().format('LLLL'); // Monday, May 13, 2019 9:38 PM
        moment().format('llll'); // Mon, May 13, 2019 9:38 PM
                        
     */


    static getDateIntervalStartSpec(now: Date, intervalMs: number): string {
        let tsVal: number = now.getTime();
        tsVal -= intervalMs;
        let ts1: Date = new Date(tsVal);
        // let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
        return TimeUtils.formatTimezoneOffset(ts1);
    }

    static formatTimezoneOffset(ts1: Date) {
        // use local time display with timezone offset in UTC format
        let tzOffset = ts1.getTimezoneOffset();
        let tzOffsetString = "+" + ("" + (-tzOffset / 60)).padStart(2, '0') + ":00";
        let dateOffset = new Date(ts1.getTime() - (tzOffset * 60000)).toISOString().replace(/\..+/, '') + tzOffsetString;
        return dateOffset;
    }

    static addMonth(now: Date) {
        var adj: Date = new Date(now.getFullYear() + (now.getMonth() === 11 ? 1 : 0), (now.getMonth() + 1) % 12, now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
        return adj;
    }

    static subtractMonth(now: Date) {
        var adj: Date = new Date(now.getFullYear() - (now.getMonth() > 0 ? 0 : 1), (now.getMonth() - 1 + 12) % 12, now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
        return adj;
    }

    static getFirstDay(now: Date) {
        var adj: Date = new Date(now.getFullYear(), now.getMonth(), 1);
        return adj;
    }

    static getLastDay(now: Date) {
        let nextMonth = TimeUtils.addMonth(now);
        var adj: Date = new Date(nextMonth.getFullYear(), nextMonth.getMonth(), 0);
        return adj;
    }

    static buildTimeframeSpec(mode: number) {
        let timeframe: ITimespanString = {
            start: null,
            end: null
        };
        let ts: Date;
        switch (mode) {
            case EIntervalMode.allTime:
                timeframe.start = null;
                timeframe.end = null;
                break;
            case EIntervalMode.year:
                ts = new Date();
                timeframe.end = TimeUtils.formatTimezoneOffset(ts);
                ts.setMonth(0);
                ts.setDate(1);
                ts.setHours(0);
                ts.setMinutes(0);
                ts.setSeconds(0);
                ts.setMilliseconds(0);
                timeframe.start = TimeUtils.formatTimezoneOffset(ts);
                break;
            case EIntervalMode.month:
                ts = new Date();
                timeframe.end = TimeUtils.formatTimezoneOffset(ts);
                ts.setDate(1);
                ts.setHours(0);
                ts.setMinutes(0);
                ts.setSeconds(0);
                ts.setMilliseconds(0);
                timeframe.start = TimeUtils.formatTimezoneOffset(ts);
                break;
            case EIntervalMode.week:
                ts = new Date();
                timeframe.end = TimeUtils.formatTimezoneOffset(ts);
                timeframe.start = TimeUtils.getDateIntervalStartSpec(ts, 7 * 86400 * 1000);
                break;
            case EIntervalMode.day:
                ts = new Date();
                timeframe.end = TimeUtils.formatTimezoneOffset(ts);
                timeframe.start = TimeUtils.getDateIntervalStartSpec(ts, 86400 * 1000);
                break;
            case EIntervalMode.currentMonth:
                ts = new Date();
                timeframe.end = TimeUtils.formatTimezoneOffset(TimeUtils.getLastDay(ts));
                timeframe.start = TimeUtils.formatTimezoneOffset(TimeUtils.getFirstDay(ts));
                break;
            case EIntervalMode.previousMonth:
                ts = new Date();
                timeframe.end = TimeUtils.formatTimezoneOffset(TimeUtils.getLastDay(TimeUtils.subtractMonth(ts)));
                timeframe.start = TimeUtils.formatTimezoneOffset(TimeUtils.getFirstDay(TimeUtils.subtractMonth(ts)));
                break;
            case EIntervalMode.nextMonth:
                ts = new Date();
                timeframe.end = TimeUtils.formatTimezoneOffset(TimeUtils.getLastDay(TimeUtils.addMonth(ts)));
                timeframe.start = TimeUtils.formatTimezoneOffset(TimeUtils.getFirstDay(TimeUtils.addMonth(ts)));
                break;
            default:
                break;
        }
        return timeframe;
    }

    static formatLocale(timestampLocale: string) {
        let ts1: Date = new Date(timestampLocale);
        // let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
        // use local time display with timezone offset in UTC format
        let tzOffset = ts1.getTimezoneOffset();
        let tzOffsetString = "+" + ("" + (-tzOffset / 60)).padStart(2, '0') + ":00";
        let dateOffset = new Date(ts1.getTime() - (tzOffset * 60000)).toISOString().replace(/\..+/, '') + tzOffsetString;
        return dateOffset;
    }
}




